import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { BlogCategoryApis } from '../../apis/BlogCategoryApis';
import './style.css';

export default function BlogCategories() {
    const [categories, setCategories] = useState([]);
    const [newName, setNewName] = useState('');
    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState('');
    const [error, setError] = useState('');
    const [adding, setAdding] = useState(false);
    const history = useHistory();

    const fetchCategories = useCallback(() => {
        return BlogCategoryApis.listAll()
            .then(res => {
                setCategories(res.data.categories || []);
            })
            .catch(err => {
                const status = err.response?.status;
                if (status === 401) {
                    localStorage.removeItem('token');
                    history.push('/login');
                } else {
                    setError('Failed to load categories');
                }
            });
    }, [history]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    const handleAdd = async (e) => {
        e.preventDefault();
        if (!newName.trim()) {
            setError('Please enter a category name.');
            return;
        }
        setError('');
        setAdding(true);
        try {
            await BlogCategoryApis.create({ name: newName.trim() });
            setNewName('');
            await fetchCategories();
        } catch (err) {
            const msg = err.response?.data?.error;
            setError(msg || `Failed to create category (${err.message})`);
        } finally {
            setAdding(false);
        }
    };

    const handleEditSave = async (e) => {
        e.preventDefault();
        if (!editName.trim()) return;
        setError('');
        try {
            await BlogCategoryApis.update(editId, { name: editName.trim() });
            setEditId(null);
            setEditName('');
            await fetchCategories();
        } catch (err) {
            const msg = err.response?.data?.error;
            setError(msg || `Failed to update category (${err.message})`);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this category?')) return;
        setError('');
        try {
            await BlogCategoryApis.delete(id);
            await fetchCategories();
        } catch (err) {
            const msg = err.response?.data?.error;
            setError(msg || `Failed to delete category (${err.message})`);
        }
    };

    return (
        <div className="app-layout">
            <main>
                <div className="dashboard-header">
                    <h1>Blog Categories</h1>
                </div>

                <div className="dashboard-section">
                    <form className="category-add-form" onSubmit={handleAdd}>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="New category name"
                            value={newName}
                            onChange={e => setNewName(e.target.value)}
                            disabled={adding}
                        />
                        <button type="submit" className="form-submit" disabled={adding}>
                            {adding ? 'Adding...' : 'Add Category'}
                        </button>
                    </form>

                    {error && (
                        <div className="form-error-banner">
                            {error}
                            <button className="form-error-close" onClick={() => setError('')}>✕</button>
                        </div>
                    )}

                    <table className="dashboard-table" style={{ marginTop: '1.5rem' }}>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Slug</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map(cat => (
                                <tr key={cat.id}>
                                    <td>
                                        {editId === cat.id ? (
                                            <form onSubmit={handleEditSave} className="inline-edit-form">
                                                <input
                                                    type="text"
                                                    className="form-input inline-edit-input"
                                                    value={editName}
                                                    onChange={e => setEditName(e.target.value)}
                                                />
                                                <button type="submit" className="action-btn-save">Save</button>
                                                <button type="button" className="action-btn-cancel" onClick={() => setEditId(null)}>Cancel</button>
                                            </form>
                                        ) : cat.name}
                                    </td>
                                    <td>{cat.slug}</td>
                                    <td>{new Date(cat.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                    <td>
                                        {editId !== cat.id && (
                                            <>
                                                <button
                                                    className="action-link"
                                                    onClick={() => { setEditId(cat.id); setEditName(cat.name); setError(''); }}
                                                >Edit</button>
                                                <button
                                                    className="action-link action-link-danger"
                                                    onClick={() => handleDelete(cat.id)}
                                                >Delete</button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {categories.length === 0 && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'center', color: '#9ca3af', padding: '1rem' }}>
                                        No categories yet. Add one above.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    );
}
